export default "__VITE_ASSET__590871fb__"